__turbopack_context__.v({
  "clamp": "paragraph-module__1xrwLq__clamp" + " " + __turbopack_context__.i(7213)["lineClamp"],
  "paragraphStyles": "paragraph-module__1xrwLq__paragraphStyles",
});
